import { Vue, Component, Watch } from 'vue-property-decorator';
import { isEmptyObjectCheck, isEmptyValue, sortByProperty } from '@/utils/utils';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { gooruSearchAPI } from '@/providers/apis/gooru-search/gooru-search';
import { sessionService } from '@/providers/services/auth/session';
import { markersAPI } from '@/providers/apis/markers/markers';

import { copy } from '@/utils/cohort';

@Component({
    name: 'auto-class-config',
    components: {
    },
})

export default class AutoClassConfig extends Vue {

    private get isDisabledSave() {
        let value = false;
        if (this.isLoading || this.isOnlyView) {
            value = true;
        }
        return value;
    }

    private isGradeWiseCources: boolean = false;

    private isGradeWiseMarker: boolean = false;

    private dataPropsDisplay: any = [];

    private navClassSettings: any = {
        categories: {
            label: 'Cateogry',
            items: [],
            selectedItems: [],
            fieldType: 'b-form-select',
            options: {
                'text-field': 'title',
                'value-field': 'code',
            },
            event: {
                change: this.onChangeCategories,
            },
        },
        subjects: {
            label: 'Subjects',
            items: [],
            selectedItems: [],
            fieldType: 'b-form-select',
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onSelectSubject,
            },
        },
        frameworks: {
            label: 'Frameworks',
            items: [],
            selectedItems: [],
            fieldType: 'b-form-select',
            options: {
                'text-field': 'title',
                'value-field': 'taxonomy_subject_id',
            },
            event: {
                change: this.onChangeFramework,
            },
        },
        grades: {
            label: 'Class origin',
            items: [],
            selectedItems: [],
            fieldType: 'b-form-select',
            options: {
                'text-field': 'grade',
                'value-field': 'id',
            },
        },
        student_math_level: {
            label: 'Student math level',
            selectedItems: 0,
            fieldType: 'b-input',
            options: {
                type: 'number',
                min: 0,
            },
        },
        diagnostic_applicable: {
            label: 'Diagnostic applicable',
            items: [],
            selectedItems: false,
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        route0_applicable: {
            label: 'Route0 applicable',
            items: [],
            selectedItems: false,
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
        mastery_applicable: {
            label: 'Mastery applicable',
            items: [],
            selectedItems: false,
            fieldType: 'b-form-checkbox',
            options: {
                switch: true,
            },
        },
    };
    private categorySubjectData: any = [];

    private activeSettings: any = {};

    private latestGradesList: any = [];

    private latestCourseList: any = [];

    private latestMarkerList: any = [];

    private customClassSettingHead: any = [
        {
            label: 'Category - subject - framework',
            key: 'category',
            sortable: true,
            tdClass: 'vertically-center',
        },
        {
            label: 'Other settings',
            key: 'otherSettings',
            sortable: true,
            tdClass: 'vertically-center',
        },
        {
            label: 'Course / Marker',
            key: 'course',
            sortable: true,
            tdClass: 'vertically-center',
        },
        {
            label: 'Actions',
            key: 'isAction',
            sortable: true,
            tdClass: 'vertically-center action-col',
        },
    ];

    private selectedCourse: any = '';

    private isLoading: any = false;

    private tenantConfigKeys: any = [];

    private isViewConfigForm: boolean = false;

    private selectedSubjectTitle: any = '';

    private selectedCategoryTitle: any = '';

    private isOnlyView: boolean = false;

    private enableMarkerData: any = [];

    private isEnableMarker: any = false;

    private isEnableMygooruClass: any = false;

    @Watch('navClassSettings.frameworks.selectedItems')
    private changeFw(value: any) {
        this.getEnableMarker();
        this.isGradeWiseMarker = this.isEnableMarker;
    }

    // -----------------------------------------------------------------
    // Properties

    // ------------------------------------------------------------------
    // Actions

    private async created() {
        this.activeSettings = await this.getTenantSettings();
        this.fetchTaxonomyClassifications();
        this.getTenantConfig();
        this.fetchCategoryList();
    }

    private getTenantSettings() {
        return tenantSettingsAPI.fetchActiveTenantSettings().then((settingsData: any) => {
            if (settingsData && settingsData.enable_marker) {
                this.enableMarkerData = settingsData.enable_marker;
            }
            if (settingsData && settingsData.navigator_class_setting) {
                return settingsData.navigator_class_setting;
            }
        });
    }

    private getTenantConfig() {
        tenantSettingsAPI.fetcTenantConfigKeysRaw().then((data: any) => {
            this.tenantConfigKeys = data;
            const setting = this.tenantConfigKeys.find((item: any) => item.settingKey === 'navigator_class_setting');
            if (setting && setting.accessMode && setting.accessMode === 'view') {
                this.isOnlyView = true;
            }
        });
    }

    private fetchTaxonomyClassifications() {
        this.isLoading = true;
        taxonomyAPI.fetchTaxonomyClassifications().then(async (categoryList: any) => {
            if (categoryList && categoryList.length > 0) {
                for await (const iterator of categoryList) {
                    iterator.subjectList = await taxonomyAPI.fetchSubjects(iterator.id);
                }
                this.categorySubjectData = categoryList;
                this.fetchDisplayPropParent();
                // this.isLoading = false;
            }
        });
    }

    private getCoursesBySubject(selectedFw: any, qparam: any, selectedFwCode: any) {
        const parmas = {
            'q': qparam,
            'start': 1,
            'length': 70,
            'flt.courseType': 'featured',
            'flt.subject': selectedFw,
            'flt.frameworkCode': selectedFwCode,
        };
        return gooruSearchAPI.searchCoursesBySubject(parmas).then((courseData) => {
            return courseData.searchResults;
        });
    }

    private fetchCategoryList() {
        const contentDetails = this.navClassSettings;
        taxonomyAPI.fetchTaxonomyClassifications().then((categoryList: any) => {
            const { categories } = contentDetails;
            categories.items = categoryList;
        });
    }

    private onChangeCategories(categoryCode: any) {
        this.navClassSettings.subjects.selectedItems = [];
        this.navClassSettings.frameworks.selectedItems = '';
        if (this.navClassSettings.frameworks) {
            this.navClassSettings.frameworks.selectedItems = [];
        }
        if (this.navClassSettings.grades) {
            this.navClassSettings.grades.selectedItems = [];
        }
        const catgegorySelected = this.navClassSettings.categories.items.find((cat: any) =>
            cat.code === categoryCode);
        this.getSubject(catgegorySelected.id);
        this.isGradeWiseCources = false;
    }

    private getSubject(categoryId: string) {
        const contentDetails = this.navClassSettings;
        taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            const { subjects } = contentDetails;
            subjects.items = subjectList;
        });
    }

    private onSelectSubject(subjectId: any) {
        const cateogryOptions = this.navClassSettings;
        if (this.navClassSettings.frameworks) {
            this.navClassSettings.frameworks.selectedItems = [];
        }
        if (this.navClassSettings.grades) {
            this.navClassSettings.grades.selectedItems = [];
        }
        const { frameworks, subjects } = cateogryOptions;
        const activeSubject = subjects.items.find((subject: any) => subject.id === subjectId);
        frameworks.items = activeSubject ? activeSubject.frameworks : [];
        this.onSelectSubjectForGrdaes(subjectId);
        this.navClassSettings.frameworks.selectedItems = '';
        this.isGradeWiseCources = false;
    }

    private onSelectSubjectForGrdaes(subjectId: any) {
        const cateogryOptions = this.navClassSettings;
        const { grades, subjects } = cateogryOptions;
        const activeSubject = subjects.items.find((subject: any) => subject.id === subjectId);
        taxonomyAPI.fetchTaxonomyGrades(activeSubject.id, 'GUT').then((courses) => {
            grades.items = courses ? courses : [];
        });
    }

    private async onChangeFramework() {
        const subjectId = this.navClassSettings.subjects.selectedItems;
        const categoryCode = this.navClassSettings.categories.selectedItems;
        const fwSelected = this.navClassSettings.frameworks.selectedItems;
        // const catgegorySelected = this.navClassSettings.categories.items.find((cat: any) =>
        // cat.code === this.navClassSettings.categories.selectedItems);
        this.isGradeWiseCources = false;
        this.checkCatSubTitle();
        if (this.navClassSettings.frameworks && this.navClassSettings.frameworks.selectedItems && subjectId) {
            const existingObjIndex = this.dataPropsDisplay.findIndex((item: any) => {
                return item.subjectId === subjectId &&
                    item.categoryCode === categoryCode;
            });
            if (existingObjIndex !== -1) {
                this.openErrorPopup();
            }
            const fw = this.navClassSettings.frameworks.selectedItems.split('.');
            this.onSelectSubjectForGrdaesWithFWCode(subjectId, fw[0]);
            const fwIndexList = this.navClassSettings.frameworks.items.findIndex((item: any) =>
                item.taxonomy_subject_id === this.navClassSettings.frameworks.selectedItems);
            if (fwIndexList !== -1) {
                const fwObject = this.navClassSettings.frameworks.items[fwIndexList];
                this.latestCourseList = await this.getCoursesBySubject(this.navClassSettings.frameworks.selectedItems, '*', fwObject.standard_framework_id);
                this.latestMarkerList = await this.searchMarkers(subjectId, fw[0]);
            }
        }
    }

    private onSelectSubjectForGrdaesWithFWCode(subjectId: any, fwCode: any) {
        const cateogryOptions = this.navClassSettings;
        const { grades, subjects } = cateogryOptions;
        taxonomyAPI.fetchTaxonomyGradesWithFwCode(subjectId, fwCode).then((gradeList) => {
            sortByProperty(gradeList, 'sequence', 'ASC');
            for (const iterator of gradeList) {
                iterator.selectedCourse = '';
            }
            grades.items = gradeList ? gradeList : [];
            this.latestGradesList = gradeList ? gradeList : [];

        });
    }

    private async fetchDisplayPropParent() {
        if (this.activeSettings === undefined ||
            (Object.keys(this.activeSettings).length === 0 && this.activeSettings.constructor === Object)) {
            this.isLoading = false;
            return;
        }
        this.isLoading = true;
        const categoryList = this.categorySubjectData;
        const valueData: any = this.activeSettings;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    categoryCode: propSplit[0],
                    otherValues: valueData[prop],
                    subjectId: prop,
                    framework: valueData[prop].framework,
                    coursesKeys: valueData[prop].courses ? Object.keys(valueData[prop].courses).map(Number) : [],
                    markerKeys: valueData[prop].markers ? Object.keys(valueData[prop].markers).map(Number) : [],
                    courseDetails: [],
                };
                dataValuesCalculate.push(data);
            }
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryCode;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                if (selectedSubjectIndex !== -1) {
                    const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                    iterator.subjectTitle = selectedSubject && selectedSubject.title ? selectedSubject.title : '';
                    const selectedFrameworkIndex = selectedSubject.frameworks.findIndex((frIndex: any) => {
                        return frIndex.standard_framework_id === iterator.framework;
                    });
                    let courseList = [];
                    let markerList: any = [];
                    if (selectedFrameworkIndex !== -1) {
                        const selectedFramework = categoryList[selectedCategoryIndex].
                            subjectList[selectedSubjectIndex].frameworks[selectedFrameworkIndex];
                        iterator.frameworkTitle = selectedFramework.title;
                        courseList = await this.getCoursesBySubject(
                            selectedFramework.taxonomy_subject_id,
                            '*', selectedFramework.standard_framework_id);
                        if (iterator.otherValues.markers_enabled) {
                            markerList = await this.searchMarkers(
                                iterator.subjectId,
                                selectedFramework.standard_framework_id);
                        }
                    }
                    const gradeList = await this.getGradeList(iterator.subjectId,
                        iterator.framework);
                    const classOriginObj: any = gradeList.find((item: any) =>
                        item.id === iterator.otherValues.class_origin);
                    iterator.otherValues.class_origin_title = !isEmptyObjectCheck(classOriginObj) &&
                        classOriginObj.grade ? classOriginObj.grade : '';
                    if (iterator.otherValues.markers_enabled) {
                        iterator.markerDetails = [];
                        for (const gradeIterator of iterator.markerKeys) {
                            const gradeIndex = gradeList.findIndex((gradeItem) => {
                                return gradeItem.id === gradeIterator;
                            });
                            let markerIndex = -1;
                            if (markerList && markerList.length > 0) {
                                markerIndex = markerList.findIndex((markerItem: any) => {
                                    return markerItem.id === iterator.otherValues.markers[gradeIterator];
                                });
                                const newItem = {
                                    grade: gradeList[gradeIndex].grade,
                                    id: gradeList[gradeIndex].id,
                                    markerId: markerIndex !== -1 ? markerList[markerIndex].id : '',
                                    markerTitle: markerIndex !== -1 ? markerList[markerIndex].name : '',
                                };
                                iterator.markerDetails.push(newItem);
                            }
                        }
                    } else {
                        for (const gradeIterator of iterator.coursesKeys) {
                            const gradeIndex = gradeList.findIndex((gradeItem) => {
                                return gradeItem.id === gradeIterator;
                            });
                            let courseIndex = -1;
                            if (courseList && courseList.length > 0) {
                                courseIndex = courseList.findIndex((courseItem: any) => {
                                    return courseItem.id === iterator.otherValues.courses[gradeIterator];
                                });
                            }
                            if (courseIndex === - 1) {
                                if (selectedFrameworkIndex !== -1) {
                                    const selectedFramework = categoryList[selectedCategoryIndex].
                                        subjectList[selectedSubjectIndex].frameworks[selectedFrameworkIndex];
                                    const course = await this.getCoursesBySubject(selectedFramework.taxonomy_subject_id,
                                        iterator.otherValues.courses[gradeIterator],
                                        selectedFramework.standard_framework_id);
                                    if (gradeIndex !== -1) {
                                        const newItem = {
                                            grade: gradeList[gradeIndex].grade,
                                            id: gradeList[gradeIndex].id,
                                            courseId: course && course.length > 0 ? course[0].id : '',
                                            courseTitle: course && course.length > 0 ? course[0].title : '',
                                        };
                                        iterator.courseDetails.push(newItem);
                                    }
                                }
                            } else {
                                if (gradeIndex !== -1) {
                                    const newItem = {
                                        grade: gradeList[gradeIndex].grade,
                                        id: gradeList[gradeIndex].id,
                                        courseId: courseIndex !== -1 ? courseList[courseIndex].id : '',
                                        courseTitle: courseIndex !== -1 ? courseList[courseIndex].title : '',
                                    };
                                    iterator.courseDetails.push(newItem);
                                }
                            }
                        }
                    }
                }
            }
            if (index >= dataValuesCalculate.length - 1) {
                this.isLoading = false;
            }
        }
        this.dataPropsDisplay = dataValuesCalculate;
    }

    private addClassData() {
        const that = this;
        const selectedFw = this.navClassSettings.frameworks.items.find((item: any) =>
            item.taxonomy_subject_id === this.navClassSettings.frameworks.selectedItems);
        const selectedGrdae = this.navClassSettings.grades.items.find((item: any) =>
            item.id === this.navClassSettings.grades.selectedItems);
        const selectedSubject = this.navClassSettings.subjects.items.find((item: any) =>
            item.id === this.navClassSettings.subjects.selectedItems);
        const displayArrayData: any = {
            framework: selectedFw.standard_framework_id,
            frameworkTitle: selectedFw.title,
            subjectTitle: selectedSubject.title,
            subjectId: this.navClassSettings.subjects.selectedItems,
            categoryCode: this.navClassSettings.categories.selectedItems,
            otherValues: {
                diagnostic_applicable: this.navClassSettings.diagnostic_applicable.selectedItems,
                route0_applicable: this.navClassSettings.route0_applicable.selectedItems,
                mastery_applicable: this.navClassSettings.mastery_applicable.selectedItems,
                student_math_level: parseInt(this.navClassSettings.student_math_level.selectedItems, 10),
                class_origin: selectedGrdae.id,
                class_origin_title: selectedGrdae.grade,
                course_id: this.selectedCourse,
                gradewise_course: this.isGradeWiseCources,
                markers_enabled: this.isGradeWiseMarker,
                class_version: 'premium',
                mygooru_enabled: this.isEnableMygooruClass,
            },
        };
        if (that.isGradeWiseMarker) {
            displayArrayData.markerDetails = [];
            const emptyArray = [];
            for (const gradeIterator of that.latestGradesList) {
                const selectedMarker: any = that.latestMarkerList.find((item: any) =>
                    item.id === gradeIterator.selectedMarker);
                const newItem = {
                    grade: gradeIterator.grade,
                    id: gradeIterator.id,
                    markerId: selectedMarker && selectedMarker.id ? selectedMarker.id : '',
                    markerTitle: selectedMarker && selectedMarker.name ? selectedMarker.name : '',
                };
                emptyArray.push(newItem);
            }
            displayArrayData.markerDetails = emptyArray;
        } else {
            if (!that.isGradeWiseCources) {
                const selectedCourse = that.latestCourseList.find((item: any) =>
                    item.id === that.selectedCourse);

                displayArrayData.courseTitle = selectedCourse ? selectedCourse.title : '';
            } else {
                displayArrayData.courseDetails = [];
                const emptyArray = [];
                for (const gradeIterator of that.latestGradesList) {
                    const selectedCourse: any = that.latestCourseList.find((item: any) =>
                        item.id === gradeIterator.selectedCourse);
                    const newItem = {
                        grade: gradeIterator.grade,
                        id: gradeIterator.id,
                        courseId: selectedCourse && selectedCourse.id ? selectedCourse.id : '',
                        courseTitle: selectedCourse && selectedCourse.title ? selectedCourse.title : '',
                    };
                    emptyArray.push(newItem);
                }
                displayArrayData.courseDetails = emptyArray;
            }
        }

        const existingObjIndex = this.dataPropsDisplay.findIndex((item: any) => {
            return item.subjectId === displayArrayData.subjectId &&
                item.categoryCode === displayArrayData.categoryCode;
        });

        if (existingObjIndex !== -1) {
            this.dataPropsDisplay.splice(existingObjIndex, 1);
        }
        this.dataPropsDisplay.push(displayArrayData);
        this.clearForm();
    }

    private clearForm() {
        this.navClassSettings.categories.selectedItems = [];
        this.navClassSettings.frameworks.selectedItems = [];
        this.navClassSettings.grades.selectedItems = [];
        this.navClassSettings.subjects.selectedItems = [];

        if (this.navClassSettings.markers) {
            this.navClassSettings.markers.selectedItems = false;
        }
        this.navClassSettings.diagnostic_applicable.selectedItems = false;
        this.navClassSettings.route0_applicable.selectedItems = false;
        this.navClassSettings.mastery_applicable.selectedItems = false;
        this.navClassSettings.student_math_level.selectedItems = 0;
        this.isGradeWiseCources = false;
        this.isGradeWiseMarker = false;
        this.selectedCourse = '';
        this.latestGradesList = [];
    }

    private isFormEmptyCheck() {
        if (isEmptyValue(this.navClassSettings.categories.selectedItems) ||
            isEmptyValue(this.navClassSettings.frameworks.selectedItems) ||
            isEmptyValue(this.navClassSettings.grades.selectedItems) ||
            isEmptyValue(this.navClassSettings.subjects.selectedItems) ||
            isEmptyValue(this.navClassSettings.student_math_level.selectedItems)) {
            return true;
        } else {
            return false;
        }
    }

    private async onEditData(data: any) {
        this.isLoading = true;
        const that = this;
        const contentDetails = this.navClassSettings;
        const catItem = this.categorySubjectData.find((cItem: any) => cItem.code === data.categoryCode);
        const subItem = catItem.subjectList.find((sItem: any) => sItem.id === data.subjectId);

        const { subjects, frameworks, grades } = contentDetails;

        subjects.items = catItem.subjectList;
        frameworks.items = subItem.frameworks;
        const gradeList = await this.getGradeList(data.subjectId, data.framework);
        this.latestGradesList = grades.items = gradeList ? gradeList : [];

        const fwIdForCourse = `${data.framework}.${data.subjectId}`;
        this.latestCourseList = await this.getCoursesBySubject(fwIdForCourse, '*', data.framework);

        if (data.otherValues.markers_enabled) {
            this.latestMarkerList = await this.searchMarkers(data.subjectId, data.framework);
            for (const markerIterator of data.markerDetails) {
                const markerIndex = that.latestGradesList.findIndex((grdItem: any) => grdItem.id === markerIterator.id);
                if (markerIndex !== -1) {
                    that.latestGradesList[markerIndex].selectedMarker = markerIterator.markerId;
                }
            }
        } else if (data.otherValues.gradewise_course) {
            for (const courceIterator of data.courseDetails) {
                const gradeIndex = that.latestGradesList.findIndex((grdItem: any) => grdItem.id === courceIterator.id);
                if (gradeIndex !== -1) {
                    that.latestGradesList[gradeIndex].selectedCourse = courceIterator.courseId;
                }
            }
        }
        this.navClassSettings.categories.selectedItems = data.categoryCode;
        this.navClassSettings.frameworks.selectedItems = `${data.framework}.${data.subjectId}`;
        this.navClassSettings.grades.selectedItems = data.otherValues.class_origin;
        this.navClassSettings.subjects.selectedItems = data.subjectId;
        this.navClassSettings.student_math_level.selectedItems = parseInt(data.otherValues.student_math_level, 10);
        this.navClassSettings.diagnostic_applicable.selectedItems = data.otherValues.diagnostic_applicable;
        this.navClassSettings.route0_applicable.selectedItems = data.otherValues.route0_applicable;
        this.navClassSettings.mastery_applicable.selectedItems = data.otherValues.mastery_applicable;
        if (this.navClassSettings.markers) {
            this.navClassSettings.markers.selectedItems = data!.otherValues!.markers_enabled;
        }
        this.selectedCourse = data.otherValues.course_id;
        this.isGradeWiseCources = data.otherValues.gradewise_course;
        this.isGradeWiseMarker = data!.otherValues!.markers_enabled;
        this.isViewConfigForm = true;
        this.isLoading = false;
        this.isEnableMygooruClass = data.otherValues!.mygooru_enabled;
    }

    private onDelete(data: any) {
        const selectedIndex = this.dataPropsDisplay.findIndex((item: any) => {
            return item.subjectId === data.subjectId && item.framework === data.framework;
        });
        this.dataPropsDisplay.splice(selectedIndex, 1);
    }

    private saveClassSettings() {
        const sendData: any = {};
        for (const iterator of this.dataPropsDisplay) {
            sendData[iterator.subjectId] = {
                auto_class_setup_flag: true,
                framework: iterator.framework,
                diagnostic_applicable: iterator.otherValues.diagnostic_applicable,
                route0_applicable: iterator.otherValues.route0_applicable,
                mastery_applicable: iterator.otherValues.mastery_applicable,
                student_math_level: parseInt(iterator.otherValues.student_math_level, 10),
                class_origin: iterator.otherValues.class_origin,
                course_id: iterator.otherValues.course_id,
                class_version: 'premium',
                gradewise_course: iterator.otherValues.gradewise_course,
                markers_enabled: false,
                mygooru_enabled: false,
            };
            sendData[iterator.subjectId].courses = {};
            if (iterator.otherValues.markers_enabled) {
                sendData[iterator.subjectId].markers = {};
                sendData[iterator.subjectId].markers_enabled = iterator.otherValues.markers_enabled;
                sendData[iterator.subjectId].mygooru_enabled = iterator.otherValues.mygooru_enabled;
                for (const markerIterator of iterator.markerDetails) {
                    if (!isEmptyValue(markerIterator.markerId)) {
                        sendData[iterator.subjectId].markers[markerIterator.id] = markerIterator.markerId;
                    }
                }
            } else if (iterator.otherValues.gradewise_course) {
                for (const courseIterator of iterator.courseDetails) {
                    if (!isEmptyValue(courseIterator.courseId)) {
                        sendData[iterator.subjectId].courses[courseIterator.id] = courseIterator.courseId;
                    }
                }
            }
        }
        const config: any = {};
        const settingsIndex = this.tenantConfigKeys.findIndex((item: any) => item.settingKey === 'navigator_class_setting');
        if (settingsIndex !== -1) {
            config.tenant_key = this.tenantConfigKeys[settingsIndex].settingKey;
            config.value = JSON.stringify(sendData);
            config.setting_visibility = this.tenantConfigKeys[settingsIndex].settingVisibility;
            tenantSettingsAPI.updateTenantSettings(config);
            this.hideModal();
        }
    }

    private showConfigForm() {
        this.clearForm();
        this.isViewConfigForm = true;
    }

    private hideConfigForm() {
        this.clearForm();
        this.isViewConfigForm = false;
    }

    private openPopup() {
        if (!this.isDisabledSave) {
            this.$bvModal.show('auto-class-confirmation');
        }
    }

    private hideModal() {
        this.$bvModal.hide('auto-class-confirmation');
    }

    private openErrorPopup() {
        this.$bvModal.show('auto-class-Error');
    }

    private hideErrorModal() {
        this.$bvModal.hide('auto-class-Error');
    }

    private hideErrorModalClearDetails() {
        this.$bvModal.hide('auto-class-Error');
        this.clearForm();
    }

    private checkCatSubTitle() {
        const subjectId = this.navClassSettings.subjects.selectedItems;
        const categoryCode = this.navClassSettings.categories.selectedItems;
        const subject = this.navClassSettings.subjects.items.find((item: any) => item.id === subjectId);
        const category = this.navClassSettings.categories.items.find((item: any) => item.code === categoryCode);
        this.selectedSubjectTitle = subject.title;
        this.selectedCategoryTitle = category.title;
    }

    private stillLoading() {
        if (this.isLoading || (Object.keys(this.activeSettings).length === 0 &&
            this.activeSettings.constructor === Object)) {
            return true;
        } else {
            return false;
        }
    }

    private async searchMarkers(subjectCode: any, fwCode: any) {
        // this.isLoading = true;
        const params: any = {
            filters: {
                'txFramework.fwCode': fwCode,
                'txSubject.txSubjectCode': subjectCode,
                'markerSource': 'grade',
            },
            offset: 0,
            limit: 20,
        };
        const marker = await markersAPI.searchMarkers(params);
        // const markerCount = marker.totalCount || 0;
        let markerList = [];
        sortByProperty(marker.markerList, 'sequence', 'ASC');
        markerList = marker.markerList;
        //   this.isLoading = false;
        return markerList;
    }

    private onChangeMarker() {
        this.isGradeWiseMarker = this.navClassSettings.markers.selectedItems;
    }

    private getEnableMarker() {
       this.isEnableMarker = false;
       if (!isEmptyValue(this.navClassSettings.frameworks.selectedItems)) {
            this.isEnableMarker = this.enableMarkerData.includes(this.navClassSettings.frameworks.selectedItems);
        }
       return this.isEnableMarker;
    }

    private async getGradeList(subjectId: any, frameworkId: any) {
       const list = await taxonomyAPI.fetchTaxonomyGradesWithFwCode(subjectId, frameworkId);
       sortByProperty(list, 'sequence', 'ASC');
       return list;
    }
}
